import React from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';

function ResendEmail() {
  const [email, setEmail] = React.useState('');
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState('');
  const [ok, setOk] = React.useState(false);
  const [cooldown, setCooldown] = React.useState(0);

  React.useEffect(() => {
    if (cooldown <= 0) return;
    const id = setInterval(() => setCooldown((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, [cooldown]);

  const resend = React.useCallback(async (e) => {
    e.preventDefault();
    if (pending || cooldown > 0) return;
    setError('');
    setOk(false);
    setPending(true);
    try {
      const { data } = await import('../lib/supabaseClient');
      const supabase = data?.supabase || (await import('../lib/supabaseClient')).supabase;
      // Prefer resend for pending signup
      try {
        await supabase.auth.resend({
          type: 'signup',
          email,
          options: { emailRedirectTo: `${window.location.origin}/auth/callback` },
        });
      } catch (_) {
        // Fallback to signInWithOtp to send a new magic link
        await supabase.auth.signInWithOtp({
          email,
          options: { emailRedirectTo: `${window.location.origin}/auth/callback` },
        });
      }
      setOk(true);
      setCooldown(60);
    } catch (err) {
      setError(err?.message || 'Failed to resend email.');
    } finally {
      setPending(false);
    }
  }, [email, pending, cooldown]);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={7} lg={6}>
          <h1 className="h3 mb-3">Resend Verification Email</h1>
          <p className="text-muted">
            Didn’t get the email? Enter your address and we’ll resend the magic link. If you don’t see it,
            check your Spam/Promotions folder and whitelist our sender. The link will take you back here to complete signup.
          </p>
          {ok && <Alert variant="success">If an account exists, a new link has been sent.</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={resend} className="mt-3">
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </Form.Group>
            <Button type="submit" variant="primary" disabled={pending || cooldown > 0}>
              {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend Link'}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ResendEmail;


